var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('AdminBreadCrumb',{attrs:{"title":"IPアドレスターゲティング"}}),_c('IpRangeListTargetingList',{attrs:{"lists":_vm.lists,"items":_vm.items,"loading-lists":_vm.loadingLists,"loading-items":_vm.loadingItems},on:{"getItems":_vm.getIPRangeListTargetingItems}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }